export default "__VITE_ASSET__Cz8NKLcj__"